module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-50-Classes-Active-84bd9b32a18f4423db8a9b2eff7b7025.png";